import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import PageTitle from '../UI/PageTitle'
import ExportButton from '../Buttons/ExportButton'
import Search from './Search'

interface Props {
  title: string
  count?: number
  // Rendered next to the title, for the transactions date range filter.
  leading?: ReactNode
  // Filter dropdowns, drawn beside the search box.
  filters?: ReactNode
  search: string
  onSearchChange: (value: string) => void
  onExport?: () => void
  isExportDisabled?: boolean
}

const TableToolbar = ({
  title,
  count,
  leading,
  filters,
  search,
  onSearchChange,
  onExport,
  isExportDisabled = false,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col xsm:flex-row xsm:items-center justify-between gap-5 flex-wrap'>
      <div className='flex items-center gap-4 flex-wrap'>
        <div className='flex items-center gap-2'>
          <PageTitle title={title} />
          {count !== undefined && count !== 0 && (
            <p className='text-[28px] font-bold'>({count})</p>
          )}
        </div>
        {leading}
      </div>
      <div className='flex items-center gap-4 flex-wrap'>
        {onExport && (
          <ExportButton
            text={t('export')}
            status='superAdmin'
            onClickHandler={onExport}
            disabled={isExportDisabled}
          />
        )}
        {filters}
        <Search
          filter={search}
          setFilter={(value) => onSearchChange(value ?? '')}
          className='static top-auto right-auto md:right-auto max-w-full xsm:max-w-[15.9375rem]'
        />
      </div>
    </div>
  )
}

export default TableToolbar
